import routes from 'actions/routes';
import { generateReadActionCreator, generateCreateActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    readRecents: generateReadActionCreator(routes.API_RECENTS, ACTION_NAMES.RECENTS),
    addRecent: generateCreateActionCreator(routes.API_RECENTS, ACTION_NAMES.RECENTS)
}
